import { useState } from 'react';

import { formatMomentDate } from '@utils/dateUtil';
import { CalendarIcon, DownArrowIcon } from '@assets/icons/';
import CustomIcon from '@components/utils/CustomIcon';
import { DateRangePicker } from '@components/DatePicker';
import FlightSearchBarInput from '@domain/flight/searchBar/dateSelection/FlightSearchBarInput';
import HotelSearchBarInput from '@domain/hotel/searchBar/dateSelection/HotelSearchBarInput';

import SearchBarInput from '../../SearchBarInput';
import { SearchBarDateRangePickerInputProps } from './SearchBarDateRangePickerInputInterface';

type InputComponentsType =
  | 'shopAndFlyHomePageFlight'
  | 'shopAndFlyHomePageHotel'
  | 'setur';

const InputComponents = {
  shopAndFlyHomePageFlight: FlightSearchBarInput,
  shopAndFlyHomePageHotel: HotelSearchBarInput,
  setur: SearchBarInput,
};

const SearchBarDateRangeInput: React.FC<SearchBarDateRangePickerInputProps> = ({
  dateProps: { startDate, endDate, onDatesChange, ...otherDateProps },
  error,
  inputComponent = 'setur',
  isSubmit,
  onFocus,
  onBlur,
  ...otherProps
}) => {
  const startDateString = formatMomentDate(startDate);
  const endDateFormatString = formatMomentDate(endDate);

  const [focusedInput, setFocusedInput] = useState<
    'startDate' | 'endDate' | null
  >('startDate');

  const InputComponent = InputComponents[inputComponent as InputComponentsType];

  return (
    <InputComponent
      leftIcon={() => (
        <CustomIcon
          fontSize={28}
          paletteColor='primaryBrand'
          icon={CalendarIcon}
        />
      )}
      rightIcon={() => (
        <CustomIcon
          icon={DownArrowIcon}
          fontSize={16}
          paletteColor='darkGray'
        />
      )}
      isFilled={startDateString.length > 0 || endDateFormatString.length > 0}
      InputComponent={
        startDateString || endDateFormatString
          ? `${startDateString} - ${endDateFormatString}`
          : otherProps?.placeholder || ''
      }
      isSubmit={isSubmit}
      onFocus={onFocus}
      onBlur={onBlur}
      onFocusChange={(v) => setFocusedInput(v)}
      renderOverlayContent={(closePopup) => {
        return (
          <DateRangePicker
            focusedInput={focusedInput}
            onFocusChange={(focusedInput) => {
              if (focusedInput === null) {
                closePopup();
              }
              setFocusedInput(focusedInput || 'startDate');
            }}
            startDate={startDate}
            endDate={endDate}
            onDatesChange={onDatesChange}
            {...otherDateProps}
          />
        );
      }}
      error={error}
      {...otherProps}
    />
  );
};

export default SearchBarDateRangeInput;
